import AppLayout from "@components/layout/AppLayout"
import React, { useState } from "react"
import styles from "@components/dataDisplay/premarketTable/premarket.module.css"
import Closed from "@components/dataDisplay/premarketTable/Closed"
import { Segment } from "@ts/types/segment.type"
import IndexTable from "@components/dataDisplay/premarketTable/IndexTable"
import InstrumentsTable from "@components/dataDisplay/premarketTable/InstrumentsTable"
import Footer from "@components/dataDisplay/premarketTable/Footer"

interface PremarketData {
  creationTimestamp: string
  importTimestamp: string
  segments: [Segment]
}

interface Response<Type> {
  status: "success" | "error"
  message?: string
  data?: Type
}

async function getServerSideProps(context: any) {
  const formatter = new Intl.DateTimeFormat([], {
    timeZone: "Europe/Zurich",
    hour12: false,
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  })
  const nowInZurich = formatter.format(new Date())
  const currentHour = parseInt(nowInZurich.split(":")[0])

  const isPremarket = currentHour >= 8 && currentHour < 9
  const forcePremarketShowing = !!context.query.jb

  if (!isPremarket && !forcePremarketShowing) {
    return {
      props: {
        status: "error",
        message: "Hier erscheinen jeden Montag bis Freitag von 08:00 bis 09:00 Uhr die Vorbörsenkurse von Julius Bär.",
      },
    }
  }

  const endpointDomain = process.env.WP_ENDPOINT ?? "https://wp.fuw.ch/wp-json/fuw/v1"
  const endpoint = `${endpointDomain}/marketdata/premarket`
  const premarketRequest = await fetch(endpoint)
  const response = await premarketRequest.json()
  const premarketData = response as Response<PremarketData>
  return { props: premarketData }
}

const Premarket = (response: Response<PremarketData>) => {
  const [segmentHead, setSegmentHead] = useState(0)
  let output: React.ReactElement | null = null

  if (response.message) {
    output = <Closed message={response.message} />
  }

  if (response.data) {
    output = (
      <>
        <ul className={styles.tabs}>
          {response.data.segments.map((segment: Segment, i: number) => (
            <li
              data-test-id={segment.name.toLowerCase().replace(/ /g, "-")}
              className={`${styles.tab} ${segmentHead == i ? styles.active : ""}`}
              key={i}
            >
              <button onClick={() => setSegmentHead(i)}>{segment.name}</button>
            </li>
          ))}
        </ul>
        <IndexTable segment={response.data.segments[segmentHead]} />
        <hr className={styles.divider} />
        <InstrumentsTable instruments={response.data.segments[segmentHead].instruments} />
        <Footer timestamp={response.data.creationTimestamp} />
      </>
    )
  }

  return (
    <AppLayout title="Premarket" robots="noindex,nofollow">
      {output}
    </AppLayout>
  )
}

export { getServerSideProps }
export default Premarket
